const config = {
  appName: import.meta.env.VITE_APP_NAME || 'VolleyPro',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  // Dev: relative URL via Vite proxy keeps auth cookies on the same origin (localhost:5173)
  apiUrl: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? '/api/v1' : 'http://127.0.0.1:5000/api/v1'),
  socketUrl: import.meta.env.VITE_SOCKET_URL || 'http://127.0.0.1:5000',
  isDev: import.meta.env.DEV,
};

export default config;
